module.exports = __webpack_public_path__ + "img/bedienungCrop-256--tiny.0d261d1d.png";